import { loadStripe } from "@stripe/stripe-js";

const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

/**
 * Stripe instance promise. Resolves to null if key is missing or script fails to load
 * (e.g. local dev without .env, or network/blocker). App and Elements still render;
 * payment UI will be disabled when stripe is null.
 */
export const stripePromise =
  publishableKey && publishableKey.trim()
    ? loadStripe(publishableKey).catch(() => {
        console.warn("[Stripe] Failed to load Stripe.js; payment features disabled.");
        return null;
      })
    : Promise.resolve(null);
